/*
 * Copyright © 2017 TEKTELIC Communications Inc.
 */


/*@ngInject*/
export default function AddMulticastGroupController($scope, $mdDialog, $state, $stateParams, types, multicastGroupService,
    deviceService, networkSettingsService, apiLimitsService, entityTableConfiguration) {

    var vm = this;

    vm.$onInit = function () {
        vm.entityTableConfiguration = entityTableConfiguration;

        vm.entity = {
            networkSettings: networkSettingsService.createDefaultMulticastGroupNetworkSettings(),
            apiLimits: apiLimitsService.createDefaultApiLimits()
        };

        vm.entityType = vm.entityTableConfiguration.entityType;
        vm.translations = types.entityTypeTranslations[vm.entityType];

        vm.withSteps = true;

        vm.add = add;
        vm.next = next;
        vm.cancel = cancel;
        vm.isStepCompleted = isStepCompleted;
    };

    function cancel() {
        $mdDialog.cancel();
    }

    function next() {
        if ($scope.selectedTab < 3) {
            $scope.selectedTab++;
        } else {
            $scope.selectedTab = 0;
        }
    }

    function isStepCompleted() {
        let fieldsetForm = $scope.theForm[`multicastGroupStep${$scope.selectedTab}`];
        return !fieldsetForm || fieldsetForm.$valid;
    }

    function add() {
        if ($stateParams.applicationId) {
            vm.entity.applicationId = {
                entityType: types.entityType.application,
                id: $stateParams.applicationId
            };
        }
        var newNetworkSettings = vm.entity.networkSettings;
        var newApiLimits = vm.entity.apiLimits;
        var fCnts = vm.entity.fCnts;
        multicastGroupService.saveMulticastGroup(vm.entity).then(
            (entity) => {
                vm.entity = entity;
                deviceService.saveDeviceFCnts(vm.entity.id.id, fCnts).then(
                    (fCnts) => {
                        vm.entity.fCnts = fCnts;
                        networkSettingsService.getMulticastGroupNetworkSettings(entity.id.entityType, entity.id.id).then(
                            (networkSettings) => {
                                newNetworkSettings.entityId = networkSettings.entityId;
                                newNetworkSettings.id = networkSettings.id;
                                networkSettingsService.saveMulticastGroupNetworkSettings(newNetworkSettings).then(
                                    (networkSettings) => {
                                        vm.entity.networkSettings = networkSettings;
                                        apiLimitsService.getApiLimits(entity.id.entityType, entity.id.id).then(
                                            (apiLimits) => {
                                                newApiLimits.entityId = apiLimits.entityId;
                                                newApiLimits.id = apiLimits.id;
                                                apiLimitsService.saveApiLimits(newApiLimits).then(
                                                    (apiLimits) => {
                                                        vm.entity.apiLimits = apiLimits;
                                                        $scope.theForm.$setPristine();
                                                        $mdDialog.hide();
                                                    }
                                                );
                                            }
                                        );
                                    }
                                );
                            }
                        );
                    }
                );
            }
        );
    }
}



// WEBPACK FOOTER //
// ./src/app/multicast-group/add-multicast-group.controller.js